import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export const GET_CONTRIBUTION_ERRORS_BY_REQUEST_ID_QUERY_KEY =
  'GET_CONTRIBUTION_ERRORS_BY_REQUEST_ID_QUERY_KEY';

const useGetContributionErrorsByRequestIdQuery = (requestId?: string, enabled?: boolean) => {
  const { data, isLoading } = useQuery(
    [GET_CONTRIBUTION_ERRORS_BY_REQUEST_ID_QUERY_KEY, requestId, enabled],
    () =>
      api.get<number | undefined>(
        API_URL.CONTRIBUTIONS_CONTRIBUTION_REQUESTS_ERROR_RECORDS_COUNT_BY_REQUEST_ID(requestId || '')
      ),
    {
      enabled: Boolean(requestId && enabled),
    }
  );

  return {
    errorCount: data?.data,
    isLoading,
  };
};

export default useGetContributionErrorsByRequestIdQuery;
